import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

export const Titulo = styled(Typography)``;

export const Observacao = styled(Typography)``;
